import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=6d87f75a"
import script from "./AlertPanel.vue?vue&type=script&lang=js"
export * from "./AlertPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports